export default __webpack_public_path__ + "static/media/neural_network_deeplearning.84d73b74.png";